<!-- Backdrop -->
<div class="modal-backdrop" aria-modal="true" role="dialog" (click)="onBackdrop()">
  <div class="modal" [formGroup]="form" (click)="$event.stopPropagation()" tabindex="-1">
    <header class="modal-header">
      <div class="title">
        <img src="assets/IconORA.svg" alt="" class="ico" />
        <h3>{{ 'componentsWizard.wizardV2.title' | translate }}</h3>
        <span class="step" *ngIf="step >= 1 && step <= 3">{{ 'componentsWizard.wizardV2.stepLabel' | translate: { step: step } }}</span>
      </div>
      <button type="button" class="x" (click)="onCancel()" [attr.aria-label]="'componentsWizard.wizardV2.close' | translate">✕</button>
    </header>

    <section class="modal-body" *ngIf="!loading; else loadingTpl">
      <!-- Accueil -->
      <ng-container *ngIf="step === 0">
        <div class="welcome">
          <p>{{ 'componentsWizard.wizardV2.welcome' | translate }}</p>
        </div>
      </ng-container>

      <!-- Étape 1 -->
      <ng-container *ngIf="step === 1">
        <label>{{ 'componentsWizard.wizardV2.step1.openingHours' | translate }}</label>
        <input type="text" formControlName="opening_hours" />

        <label>{{ 'componentsWizard.wizardV2.step1.hasTriage' | translate }}</label>
        <input type="checkbox" formControlName="has_triage" />
      </ng-container>

      <!-- Étape 2 -->
      <ng-container *ngIf="step === 2">
        <label>{{ 'componentsWizard.wizardV2.step2.nurses' | translate }}</label>
        <input type="number" formControlName="nurses" min="0" />

        <label>{{ 'componentsWizard.wizardV2.step2.doctors' | translate }}</label>
        <input type="number" formControlName="doctors" min="0" />
      </ng-container>

      <!-- Étape 3 -->
      <ng-container *ngIf="step === 3">
        <label>{{ 'componentsWizard.wizardV2.step3.priorityRules' | translate }}</label>
        <textarea formControlName="priority_rules" rows="4"></textarea>
      </ng-container>

      <!-- Fin -->
      <ng-container *ngIf="step === 9">
        <div class="finish">
          <p>{{ 'componentsWizard.wizardV2.finish' | translate }}</p>
        </div>
      </ng-container>
    </section>

    <ng-template #loadingTpl>
      <div class="loading">{{ 'componentsWizard.wizardV2.loading' | translate }}</div>
    </ng-template>

    <footer class="modal-footer">
      <button type="button" class="ghost" *ngIf="step < 3" (click)="onCancel()">{{ 'componentsWizard.wizardV2.footer.cancel' | translate }}</button>
      <div class="spacer"></div>

      <button type="button" class="primary" *ngIf="step === 0" (click)="start()">{{ 'componentsWizard.wizardV2.footer.start' | translate }}</button>

      <ng-container *ngIf="step >= 1 && step <= 3">
        <button type="button" class="prev" *ngIf="step > 1" (click)="prev()">{{ 'componentsWizard.wizardV2.footer.prev' | translate }}</button>
        <button type="button" class="next" *ngIf="step < 3" (click)="next()">{{ 'componentsWizard.wizardV2.footer.next' | translate }}</button>
        <button type="button" class="primary" *ngIf="step === 3" [disabled]="submitting || form.invalid" (click)="onFinish()">{{ 'componentsWizard.wizardV2.footer.finish' | translate }}</button>
      </ng-container>

      <button type="button" class="primary" *ngIf="step === 9" (click)="close.emit()">{{ 'componentsWizard.wizardV2.footer.continue' | translate }}</button>
    </footer>
  </div>
</div>
